import { render, staticRenderFns } from "./GptFileUpload.vue?vue&type=template&id=685dfdfa"
import script from "./GptFileUpload.vue?vue&type=script&lang=js"
export * from "./GptFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports